import { AbstractControl } from '@angular/forms';

/**
 * Helper function
 * Calculates the checksum, using the provided digit and
 * multiplier arrays
 */
const checksum = (num: number, mul: string) =>
  mul
    .split('')
    .map((m, i) => parseInt(num[i], 10) * parseInt(m, 10))
    .reduce((a, v) => a + v, 0);

/**
 * Helper function
 * Calculates the difference (mod 10) between 10 and the
 * checksum (mod 10)
 */
const difference = (num, mul) => (10 - (checksum(num, mul) % 10)) % 10;

/**
 * @returns
 * Validator function for validating CBU.
 *
 * @see https://es.wikipedia.org/wiki/Clave_Bancaria_Uniforme
 */
export function cbuValidator() {
  return (control: AbstractControl) => {
    // Trim any spaces added to the number
    const value: string = (control.value || '').replace(' ', '');

    // CBU numbers must be 22 digits long
    if (value.length !== 22) {
      return { cbu: 'length' };
    }

    // Calculate checksum for the bank block (7 + 1 digits) and verify
    const bank = value.substring(0, 7).split('');
    const bankCheck = value.substring(7, 8);

    if (difference(bank, '7139713').toString() !== bankCheck) {
      return { cbu: 'bank' };
    }

    // Calculate checksum for the acccount block (13 + 1 digits) and verify
    const account = value.substring(8, 21);
    const accountCheck = value.substring(21, 22);

    if (difference(account, '3971397139713').toString() !== accountCheck) {
      return { cbu: 'account' };
    }

    return null;
  };
}
